import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getFirestore, doc, getDoc, collection, getDocs } from "firebase/firestore";
import { app } from "../firebase";
import "./CollectionPage.css";
import Navbar from "../components/Navbar";
import Loading from "../components/Loading"; // your loading component

const db = getFirestore(app);

const CollectionPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [collectionData, setCollectionData] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCollection = async () => {
      try {
        const docRef = doc(db, "collections", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setCollectionData(data);

          const productDocs = await Promise.all(
            (data.productIds || []).map(async (pid) => {
              const pSnap = await getDoc(doc(db, "products", pid));
              if (!pSnap.exists()) return null;
              const productData = pSnap.data();

              // Fetch price from prices subcollection
              let price = "$0";
              const pricesSnapshot = await getDocs(collection(db, "products", pid, "prices"));
              pricesSnapshot.forEach((priceDoc) => {
                const priceData = priceDoc.data();
                if (priceData.active) {
                  price = `$${(priceData.unit_amount / 100).toFixed(2)}`;
                }
              });

              return { id: pid, ...productData, price };
            })
          );

          setProducts(productDocs.filter(Boolean));
        }
      } catch (error) {
        console.error("Error fetching collection:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCollection();
  }, [id]);

  if (loading) return <Loading />;

  return (
    <div className="CollectionPage">
      <Navbar />
      <img
        src={collectionData.banner}
        alt={collectionData.name}
        className="CollectionPage_Banner"
      />
      <div className="CollectionPage_BannerText">
        <h2>{collectionData.name}</h2>
        <p>{collectionData.description}</p>
      </div>

      <div className="CollectionPage_Products">
        {products.map((product) => (
          <div
            key={product.id}
            className="ProductCard"
            onClick={() => navigate(`/product/${product.id}`)}
          >
            <img src={product.images?.[0] || "/images/default.png"} alt={product.name} />
            <h3>{product.name}</h3>
            <p className="ProductCard_Price">{product.price}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CollectionPage;
